import { IElement } from "core-integration/src/store/elements/types";
import { DifficultyRating } from "plos/src/styles/difficultyColors";

/**
 * Maps a player's next projected price-change likelihood onto the difficulty
 * colour scale used by the status chip: 1 very likely to rise ... 3 no change
 * ... 5 very likely to drop. Likelihood is a signed band where +/-5 is very
 * likely and +/-4 is likely; anything smaller reads as no change.
 */
export const getPriceChangeStatus = (element: IElement): DifficultyRating => {
  switch (element.price_change_projections?.[0]?.likelihood) {
    case 5:
      return 1;
    case 4:
      return 2;
    case -4:
      return 4;
    case -5:
      return 5;
    default:
      return 3;
  }
};

export const priceChangePredictionEnabled =
  import.meta.env.VITE_PRICE_CHANGE_PREDICTION_ENABLED === "true";
